import React from 'react';
import { IconUnderlay } from '@advisorycloud/react-ui-components';
import { Paper, Typography } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHighOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { useTranslation } from 'react-i18next';

const useStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '580px',
    alignItems: 'center',
    paddingTop: '30px',
  },
  titleContainer: {
    maxWidth: '360px',
    marginTop: '20px',
    marginBottom: '40px',
    textAlign: 'center',
  },
  retryButton: {
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    flexDirection: 'row',
    width: '80px',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  retryText: {
    marginLeft: '5px',
    color: 'primary.main',
  },
  priorityIcon: {
    fontSize: '60px',
  },
});

function UnhandledError({ isSM, onRetry, isAbleToRetry }) {
  const classes = useStyles(isSM);
  const { t } = useTranslation();

  function renderRetryButton() {
    if (isAbleToRetry) {
      return (
        <button onClick={onRetry} style={classes.retryButton} type="submit">
          <RefreshOutlinedIcon color="primary" />
          <Typography color="textSecondary" variant="h3" sx={classes.retryText}>
            {t('RETRY-BUTTON-TEXT')}
          </Typography>
        </button>
      );
    }

    return null;
  }

  return (
    <Paper
      data-cy="unhandled-error-card"
      sx={classes.container}
      elevation={isSM ? 0 : 2}
    >
      <IconUnderlay size={80}>
        <PriorityHighIcon color="error" style={classes.priorityIcon} />
      </IconUnderlay>

      <div style={classes.titleContainer}>
        <Typography color="textSecondary" variant="h2">
          {t(
            isAbleToRetry
              ? 'UNHANDLED-RETRY-ERROR-TEXT'
              : 'UNHANDLED-ERROR-TEXT'
          )}
        </Typography>
      </div>
      {renderRetryButton()}
    </Paper>
  );
}

export default UnhandledError;
